import {
  Legend,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  Tooltip,
} from "recharts";
import "./Radar.css";
import {
  IJob,
  IResultDisplay,
  IExpertise,
  IResultScoreItem,
} from "../../../../Interfaces";
import { useState, useEffect, FC } from "react";

interface IRadarProp {
  expertiseData: IResultDisplay;
  isMobile: boolean;
  jobDataBalance: IJob | null;
}

interface IData {
  jobScore?: number;
  name: string;
  pourcentage: number;
  max: number;
}

const RadarComponent: FC<IRadarProp> = ({
  isMobile,
  expertiseData,
  jobDataBalance,
}) => {
  const title = "Score détaillé";
  const [data, setData] = useState<IData[]>([]);

  
  const display = () => {
    
      const filterJobData = jobDataBalance?.domain.find((item: IExpertise) => {
        return item.expertiseName === expertiseData.name;
      })?.scoreItems;    
      
      if (filterJobData) {
        const dataToDisplay = expertiseData.scoreItems.map(
          (item: IResultScoreItem, index: number) => {
            
            if (item.name === filterJobData[index].domain) {
              return { ...item, jobScore: filterJobData[index].scores };
            }
            return item;
          }
        );     
        setData(dataToDisplay);
      } else {
        
        setData(expertiseData.scoreItems);
      }
  
  };

  useEffect(() => {    
    display();    

    // eslint-disable-next-line
  }, [expertiseData]);

  return (
    <div className="userResultRadar">
      <h3>{title.toUpperCase()}</h3>
      <div className="radar">
        <RadarChart
          cx="50%"
          cy="50%"
          width={isMobile ? 296 : 800}
          height={isMobile ? 296 : 400}
          data={data}
          startAngle={45}
          endAngle={-310}
        >
          <PolarGrid gridType="circle" />
          <PolarAngleAxis
            dataKey="name"
            tickLine={true}
            axisLine={true}
            tick={{ fontSize: isMobile ? 10 : 14, width: isMobile ? 88 : 130 }}
          />
          <Radar
            name="Mon résultat"
            dataKey={data?"pourcentage":0}
            stroke="#4A8CCA"
            fill="#3E8FC654"
            fillOpacity={0.6}
          />
          <Radar
            name="Attendu"
            dataKey={data ? "jobScore" :0}
            stroke="#F8485E"
            fill="#FDDADE54"
            fillOpacity={0.6}
          />
          <Radar
            name="max"
            dataKey={data? "max": 0}
            stroke="transparent"
            fill="transparent"
            fillOpacity={0.6}
          />
          <Tooltip wrapperStyle={{ fontSize: "15" }} />
          <Legend
            layout="horizontal"
            align="center"
            height={40}
            fontSize={13}
            wrapperStyle={{ margin: "50"}}
          />
        </RadarChart>
      </div>
    </div>
  );
};
export default RadarComponent;
